import { CommonService } from './../Services/common.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from "rxjs";
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie';
import { SettingService } from '../Services/setting.service';
import { browserRefresh } from '../app.component';
@Component({
  selector: 'app-email-otp-verify',
  templateUrl: './email-otp-verify.component.html',
  standalone:false,
  styleUrls: ['./email-otp-verify.component.scss']
})
export class EmailOtpVerifyComponent implements OnInit {

  modalObservable: Subject<void> = new Subject<void>();
  UpdateEmail: string = "";
  IDNo: string = "";
  NewEMail: string;
  NewMOb: any;
  Replace: any;

  constructor(private _route: ActivatedRoute, private CommonService: CommonService, public auth: AuthService, private setting: SettingService,

    private cookieService: CookieService, private _router: Router) { }

  @Output() doneButton: EventEmitter<any> = new EventEmitter<any>();

  mobilemask: string = "";
  email: string = "";
  maskemail: string = "";
  otp: string = "";
  emailId:string
  timerexpire: string;
  OptTimerbtnShow: boolean = true;
  timeoutHandle;
  idno;
  public browserRefresh: boolean;



  async ngOnInit(): Promise<any> {

    this.browserRefresh = browserRefresh;

    console.log('refreshed?:', browserRefresh);



// 
this.CommonService.presentLoading();
this.auth.accessToken = await this.CommonService.Get("token");
this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
  if (data?.response?.code == 1) {
    this.emailId=data?.response?.content?.emailId
   this.CommonService.hideLoading();
   this.startTime();


  }
  else {
    await this.CommonService.hideLoading();
    this.CommonService.ParseErrorAlert("", "", this._router, data);
  }

});
// 

    this._route.queryParams.subscribe(params => {
      if (params) {

        if (params['maskemail']) {

          // this.maskemail = params.maskemail;
          // this.Replace = params.Replace;

        }
        if (params['UpdateEmail']) {

          this.UpdateEmail = params['UpdateEmail'];
        }
        if (params['IDNo']) {

          this.IDNo = params['IDNo'];
        }
      }
    });

    if (this.maskemail == undefined || this.maskemail == '') {

      let E =await this.cookieService.get("eRef", true);
      if (E) {

        this.maskemail = E;

      }
    }

    if (this.auth?.RegisteredUser == undefined && (this.IDNo == "" || this.IDNo == undefined)) {

      let R = await this.cookieService.get("xVal", true);
      if (R) {

        this.IDNo = R;

      }

    }


    this.auth.accessToken = await this.CommonService.Get("token");








    let UE =await this.cookieService.get("UpdatedEmail", false);
    if (UE) {

      this.NewEMail = JSON.parse(UE);

      this.maskemail = this.CommonService.maskEmail(this.NewEMail);
    }
    let UM =await this.cookieService.get("upM32B", true);
    if (UM) {

      this.NewMOb = JSON.parse(UM);

    }
  }

  Next() {

    this._router.navigateByUrl("/MobileOtpVerify");
    // this.VerifyEmailOtp();
    // if (this.NewEMail != undefined && this.NewEMail != "") {
    //   this.VerifyEmailOtp();
    // }
    // else if (this.NewMOb != undefined && this.NewMOb != "") {

    //   this.verifyViaEmailOtp();
    // }
    // else if (this.Replace != undefined && this.Replace != "" && this.Replace == 'PhyReplace') {

    //   // this.CardReplacementVerifyOTP();
    // }
    // else {

    //   this.LoginRegisterEmailOTP()
    // }
  }


  async VerifyEmailOtp() {
    let body = {
      EmailId: this.emailId,
      OTPCode: this.otp,
    };

    await this.CommonService.presentLoading();
    this.setting.VerifyChangeEmailOTP(this.auth.accessToken, body)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          await this.CommonService.hideLoading();
          //this.showModal(num);
          this._router.navigateByUrl("/MobileOtpVerify");

        } else {
          await this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }


  verifyViaEmailOtp() {
    let body = {
      MobileNumber: this.NewMOb,
      OTPCode: this.otp,
    };
    this.CommonService.presentLoading();
    this.setting
      .VerifyChangeMobileEmailOTP(this.auth.accessToken, body)
      .then((data: any) => {
        if (data?.response.code == 1) {
          this.CommonService.hideLoading();
          this._router.navigateByUrl("/VerifyMobileOtp");
        } else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  LoginRegisterEmailOTP() {


    this.CommonService.presentLoading();
    if (this.maskemail && this.UpdateEmail != '') {

      let body = {
        UniqueId: this.CommonService.Guid(),
        IdNumber: this.IDNo ? this.IDNo : this.auth.RegisteredUser.idno,
        EmailId: this.UpdateEmail,
        isBusiness: false,
        firebaseToken: "string",
        otp: this.otp

      }
      this.auth.SendUpdateEmailSMSOTP(body).then((data: any) => {

        console.log('SendUpdateEmailSMSOTP', data);

        if (data?.response?.code == 1) {
          this.CommonService.hideLoading();
          // this._router.navigateByUrl("/VerifyMobileOtp");
          this._router.navigate(['/VerifyMobileOtp'], { queryParams: { 'IDNo': this.IDNo, 'UpdateEmail': this.UpdateEmail } });

        }
        else {
          this.CommonService.hideLoading();
          this.CommonService.ParseErrorAlert('', 'OK', this._router, data);
        }

      })

    }
    else {

      let body = {
        UniqueId: this.CommonService.Guid(),
        idNumber: this.auth.RegisteredUser?.idno ? this.auth.RegisteredUser.idno : this.IDNo,
        isBusiness: false,
        firebaseToken: "string",
        otp: this.otp
      }
      this.auth.LoginRegisterEmailOTP(body).then((data: any) => {

        if (data?.response?.code == 1) {
          console.log('LoginRegisterEmailOTP', data);

          // this.CommonService.maskMobileNumber();
          // console.log('MobileNo',this.CommonService.maskMobileNumber('34534534345'));
          this.CommonService.hideLoading();
          this._router.navigateByUrl("/VerifyMobileOtp");
          // if(email){
          //   this._router.navigate(['/MobileNumber'],{queryParams:{maskemail,email,id:this.Idnumber}});  
          // }
          // this._router.navigateByUrl("/MobileNumber");

          // if(data.response.content.l.pinCreated){
          //   this._router.navigateByUrl("/DashboardLoans");

          // }else{
          //   this._router.navigateByUrl("/CreateAppPin");
          // }
          // ('LoginRegister',data.response.content.l);

        } else {
          this.CommonService.hideLoading();

          this.CommonService.ParseErrorAlert('', '', this._router, data);

        }
      });
    }



  }


  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter") {

      if (this.NewEMail != undefined && this.NewEMail != "") {

        this.VerifyEmailOtp();
      }
      else if (this.NewMOb != undefined && this.NewMOb != "") {
        this.verifyViaEmailOtp();
      }
      else if (this.Replace != undefined && this.Replace != "" && this.Replace == 'PhyReplace') {
        // this.CardReplacementVerifyOTP();
      }
      else {

        this.LoginRegisterEmailOTP()
      }
    }
  }


  // CardReplacementVerifyOTP(){
  //
  //     let data = {
  //       internalCardId: this.selectedCardDetail?.internalId,
  //       Status: "REPLACE",
  //       ReplaceReason: this.selectedReasonId,
  //       OTPCode: this.otp,
  //     };
  //     this.commonP.presentLoading();
  //     this.auth
  //       .CardReplacementVerifyOTP(data, this.auth.accessToken)
  //       .then(async (data: any) => {
  //         if (data?.response?.code == 1) {
  //           await this.commonP.hideLoading();
  //           this._router.navigate(["/CardReplacementSuccess"], {
  //             queryParams: { ReplaceCard: true },
  //           });
  //         } else {
  //           await this.commonP.hideLoading();
  //           this.commonP.ParseErrorAlert("", "", this._router, data);
  //         }
  //       });
  // }

  // CardReplacementSendOTP(){
  //   this.auth
  //   .CardReplacementSendOTP({}, this.auth.accessToken)
  //   .then((data: any) => {
  //     if (data?.response?.code == 1) {

  //       this.commonP.hideLoading();
  //       this.otp = "";
  //       this.showModal("close", "");
  //       // this.showModal(14, '');

  //     //  let email = this.auth.RegisteredUser?.email;
  //       let email = this.auth.detailuser?.emailId;

  //       this.maskemail = this.commonP.maskEmail(email);
  //       this._router.navigate(["/VerifyEmailOtp"], {
  //         queryParams: {maskemail: this.maskemail,Replace:'PhyReplace'},
  //       });        } 
  //       else {
  //       this.commonP.presentLoading();
  //       this.commonP.ParseErrorAlert("", "", this._router, data);
  //     }
  //   });
  // }



  showModal(num) {

    this.modalObservable.next(num);
  }

  // onKeyDown(event: KeyboardEvent): void {

  //   if (event.key === 'Enter') {
  //     this.LoginRegisterEmailOTP();

  //   }
  // }

  // startTime() {
  //   var str = "1:57";

  //   var array = str.split(":");
  //   this.countdown(parseInt(array[0]), parseInt(array[1]));
  // }

  // countdown(minutes, seconds) {
  //   this.timeoutHandle;
  //   var that = this;
  //   function tick() {
  //     that.timerexpire =
  //       minutes.toString() + ":" + (seconds < 10 ? "0" : "") + String(seconds);
  //     seconds--;
  //     if (seconds >= 0) {
  //       that.timeoutHandle = setTimeout(tick, 1000);
  //     } else {
  //       if (minutes >= 1) {
  //         setTimeout(function () {
  //           that.countdown(minutes - 1, 59);
  //         }, 1000);
  //       }
  //     }

  //     if (that.timerexpire == "0:00") {
  //       that.OptTimerbtnShow = false;
  //     }
  //   }
  //   tick();
  // }

    // new timer
  startTime() {
  const expireTime = new Date().getTime() + 2 * 60 * 1000; // 2 minutes from now
  this.startCountdown(expireTime);
}

startCountdown(expireTimestamp: number) {
  const tick = () => {
    const now = new Date().getTime();
    const remaining = expireTimestamp - now;

    if (remaining <= 0) {
      this.timerexpire = "0:00";
      this.OptTimerbtnShow = false;
      return;
    }

    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    this.timerexpire = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    setTimeout(tick, 1000);
  };

  tick();
}


  ResendOtp() {

    this.CommonService.presentLoading();

    let body = {
      UniqueId: this.CommonService.Guid(),
      idNumber: this.auth?.RegisteredUser?.idno ? this.auth.RegisteredUser.idno : this.IDNo

    }

    this.auth.SendOTPByIDNumber(body).then(async (data: any) => {
      //
      if (data?.response?.code == 1) {

        this.OptTimerbtnShow = true;
        this.startTime();
        let email = data?.response?.content?.email;
        this.maskemail = this.CommonService.maskEmail(email);
        this.auth.RegisteredUser.idno = await this.cookieService.get("tempValue", true);
        this.CommonService.hideLoading();

      }
      else {
        this.CommonService.hideLoading();
        this.CommonService.ParseErrorAlert('', '', this._router, data);
      }
    })

    // this.auth.ResendSMSRegistrationOTP(body, this.auth.accessToken).then((data: any) => {
    //   if (data?.response?.code == 1) {
    //     this.OptTimerbtnShow = true;
    //     this.startTime();
    //     this.CommonService.hideLoading();
    //   }
    //    else {
    //     this.CommonService.hideLoading();
    //     this.CommonService.ParseErrorAlert('', '', this._router, data);

    //   }
    // });
  }


  continue() {
    this._router.navigateByUrl("/UploadId");
  }

  isValid() {
    if (!this.otp) {
      return true
    } else {
      return false

    }
  }

  onOtpChange(e) {
    if (e.length == 4) {
      this.otp = e.toString();
    } else {
      this.otp = "";
    }
  }

}

